'use strict';

var hasAttribute = require('./has-attribute');

/**
 * Estensione che permette di effettuare il toggle di un attributo come .toggleClass() per una classe
 * @param attr
 * @param $el
 * @returns $el
 */
module.exports = function toggleAttribute(attr, $el) {
    $el.each(function () {
        if (!hasAttribute(attr, $(this))) {
            $(this).attr(attr, attr);
        } else {
            $(this).removeAttr(attr);
        }
    });

    return $el;
};
